import { Link, Navigate } from "react-router-dom";
import { ArrowLeft, ArrowRight, Check } from "lucide-react";
import Seo from "../components/Seo";
import Reveal from "../components/Reveal";
import { DETAIL } from "../content/services";

export default function ServicePage({ slug }) {
  const data = DETAIL[slug];
  if (!data) return <Navigate to="/" replace />;

  return (
    <>
      <Seo title={data.h1} description={data.description} path={`/${slug}`} />

      <section className="bg-paper pb-12 pt-12 lg:pb-16 lg:pt-16" data-testid="service-page">
        <div className="container-site">
          <Reveal>
            <Link
              to="/servizi"
              data-testid="service-back-link"
              className="inline-flex items-center gap-1.5 text-sm font-medium text-muted transition-colors hover:text-petrolio"
            >
              <ArrowLeft size={16} /> Tutti i servizi
            </Link>
            <h1 className="mt-6 max-w-3xl font-display text-3xl font-extrabold tracking-tight text-antracite sm:text-4xl lg:text-5xl">
              {data.h1}
            </h1>
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-muted sm:text-lg">{data.intro}</p>
          </Reveal>
        </div>
      </section>

      <section className="pb-20 lg:pb-24">
        <div className="container-site grid max-w-5xl gap-12">
          <Reveal>
            <div>
              <h2 className="font-display text-xl font-bold text-antracite sm:text-2xl">Quando può essere utile</h2>
              <ul className="mt-5 space-y-3">
                {data.quando.map((q, i) => (
                  <li key={i} className="flex gap-3 text-sm leading-relaxed text-antracite-soft sm:text-base" data-testid={`service-quando-${i}`}>
                    <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-salvia" />
                    {q}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          <Reveal>
            <div>
              <h2 className="font-display text-xl font-bold text-antracite sm:text-2xl">Cosa possiamo fare</h2>
              <ul className="mt-5 grid gap-3 sm:grid-cols-2">
                {data.cosa.map((c, i) => (
                  <li
                    key={i}
                    data-testid={`service-cosa-${i}`}
                    className="flex items-start gap-3 rounded-xl border border-line bg-white p-4 text-sm leading-relaxed text-antracite-soft"
                  >
                    <Check size={16} className="mt-0.5 shrink-0 text-petrolio" />
                    {c}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>

          {data.nota && (
            <Reveal>
              <p className="max-w-3xl rounded-xl bg-fog p-4 text-xs leading-relaxed text-muted" data-testid="service-nota">
                {data.nota}
              </p>
            </Reveal>
          )}

          {data.aDistanza && (
            <Reveal>
              <div className="rounded-2xl bg-petrolio p-6 text-paper sm:p-8" data-testid="service-remote-box">
                <p className="text-xs font-bold uppercase tracking-[0.22em] text-salvia">{data.remoteLabel || "Gestione a distanza"}</p>
                <p className="mt-3 text-sm leading-relaxed text-paper/85 sm:text-base">{data.aDistanza}</p>
              </div>
            </Reveal>
          )}
        </div>
      </section>

      <section className="border-t border-line bg-fog py-14">
        <div className="container-site flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-center">
          <div>
            <h2 className="font-display text-xl font-bold text-antracite sm:text-2xl">Hai bisogno di questo servizio?</h2>
            <p className="mt-1.5 text-sm text-muted">Prima valutazione gratuita, risposta entro 24 ore.</p>
          </div>
          <Link
            to={`/richiedi-valutazione?servizio=${encodeURIComponent(data.formService)}`}
            data-testid="service-cta"
            className="btn-primary whitespace-nowrap"
          >
            Richiedi una valutazione gratuita <ArrowRight size={16} />
          </Link>
        </div>
      </section>
    </>
  );
}
